// fileupload info for all companies, etc
import Promise from 'bluebird'
import _ from 'lodash'
import api from '../../axios_api'
import router from '../../main'

const state = {
  file: [],
  showModal: true
}

const getters = {
  filesByInvestmentId: (state) => (id) => {

    return _.filter(state.file, function (o) { return o.document_id === id }) || []
  },
  filesByPortfloioId: (state) => (id) => {
    let retval = _.filter(state.file, function (o) { return o.portfolio_item === id }) || [];
    if (retval.length == 0) {
      return retval;
    }
    retval.map((item) => {
      if (item) {
        item.date = item.date ? item.date : item.modified;
      }
    });
    return retval.sort((a, b) => {
      return new Date(a.date) - new Date(b.date);
    })
  },
  files: (state) => state.file,
  showAddModal: (state) => state.showModal,
  allFiles: function (state, getters, rootState, rootGetters) {
    let retval = JSON.parse(JSON.stringify(state.file));
    if (retval.length == 0) {
      return retval;
    }
    let portfolioAll = rootGetters['portfolio/portfolioAll'];
    retval.map((item) => {
      if (item) {
        if (item.portfolio_item) {
          item.portfolioDetails = portfolioAll.find(portfolioItem => portfolioItem._id == item.portfolio_item)
        }
        item.date = item.date ? item.date : item.modified;
      }
    });
    return retval.sort((a, b) => {
      return new Date(a.date) - new Date(b.date);
    })
  }
}


const buildFormData = function (payload) {
  let formData = new FormData();  /*
      Add the form data we need to submit
  */
  for (var i = 0; i < payload.files.length; i++) {
    let file = payload.files[i];

    

    if (!file) {
      let mimeType = "text/plain";

      if(payload.notificationFiles && payload.notificationFiles[i] && payload.notificationFiles[i].type) {
        mimeType = payload.notificationFiles[i].type;
      } else if(payload.data && payload.data[i] && payload.data[i].type) {
        mimeType = payload.data[i].type;
      }

      file = new Blob(['test'], { type: mimeType +";charset=utf-8" });
    }
    
    formData.append(
      'files[' + i + ']',
      file,
      (file ? file.name : '')
    );
  }
  formData.append('encrypt', JSON.stringify({ encrypt: { data: payload.data } }));

  return formData;
}


const mutations = {
  initialize(state) {
    state.file = []
  },
  merge(state, payload) {
    // merge our local with what has returned
    if (_.isNil(payload) || _.isEmpty(payload)) return
    if (!_.isArray(payload)) payload = [payload]
    state.file = _.map(state.file, addr => {
      let index = _.findIndex(payload, function (a) { return a._id === addr._id })
      if (index >= 0) {
        return _.first(_.pullAt(payload, index))
      }
      return addr
    })
    if (!_.isEmpty(payload)) state.file = _.concat(state.file, payload)
    state.file = _.without(state.file, null, undefined)
  },
  overwrite(state, payload) {
    // stomp on our current data, this will wipe out local changes
    state.file = payload;
  },
  remove(state, payload) {
    if (_.isNil(payload) || _.isEmpty(payload)) return
    // remove the item by the id (either _id or uaid)
    state.file = _.filter(state.file, function (a) { return a._id !== payload })
  },
  showAddModal(state, payload) {
    state.showModal = payload;
  }
}

const actions = {
  start({ state, dispatch, commit }) {
    commit('initialize');
    dispatch('getFile')
      .then(() => {

      })
      .catch(() => { })
  },
  stop({ commit }) {
    // clean up
    commit('initialize')
  },
  cycle({ }) { },

  deleteFile({ commit }, payload) {
    // delete file
    if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'no arguments' })
    // delete the file with the given id
    let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/file/${payload}`;
    return api.delete(url)
      .then(res => {
        // remove the id from our local file list
        commit('remove', payload)
        // should be 204
        return Promise.resolve()
      })
      .catch(err => {
        console.error(`Error during file delete: ${err}`)
        return Promise.reject(err)
      })
  },
  getFile({ commit }, payload) {
    if (localStorage.fiifi) {
      let fiifi = JSON.parse(localStorage.fiifi).user
      if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
        let url = `${fiifi.id}/${fiifi.workspace_id}/file`;
        return api.get(url, {})
          .then(res => {
            // merge returns with our data
            commit('merge', res.data.encrypt.data)
            return Promise.resolve(res.data.encrypt.data)
          })
          .catch(err => {
            console.error(`Error during file fetch: ${err}`)
            return Promise.reject(err)
          })
      }
    }
  },
  updateFile({ commit }, payload) {
    // put file
    if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'no arguments' })

    let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/file`;

    return api.put(url, { encrypt: { data: payload } })
      .then(res => {
        commit('merge', payload);

        return Promise.resolve()
      })
      .catch(err => {
        console.error(`Error during file delete: ${err}`)
        return Promise.reject(err)
      })
  },
  createFile({ commit }, payload) {
    // put file
    if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'no arguments' })
    // delete the file with the given id
    // return api.put(`/file`, { encrypt: { data: payload } })

    let formData = buildFormData(payload);
    let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/file`;

    return api.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
      .then(res => {
        return Promise.resolve(res)
      })
      .catch(err => {
        console.error(`Error during file upload: ${err}`)
        return Promise.reject(err)
      })
  },
  apiDeleteFilesForCompany({ dispatch, rootGetters }, payload) {
    // delete all attachments for company, then do a hard fetch
    if (_.isNil(payload) || _.isEmpty(payload) || !payload.ucid) return Promise.reject({ error: 'Missing requried paraeters.' })
    let currentRole = rootGetters['role/current_role'];
    let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/file/company/${payload.ucid}`;
    // if (currentRole && currentRole._id) {
    //   url = `/attachment/company/${payload.ucid}?account=${currentRole.account}`;
    // } else url = `/attachment/company/${payload.ucid}`
    return api.delete(url)
      .then(res => {
        // clean, hard fetch
        return dispatch('apiCleanFetchAttachment')
      })
      .catch(err => {
        console.error(`Error deleting attachments: ${err}`)
        return Promise.reject({ error: err })
      })
  },
  apiCleanFetchAttachment({ commit }) {
    // full fetch from the server, overwriting local infos
    return new Promise((resolve, reject) => {
      let params = {}
      params.force = true
      let url = `${router.currentRoute.params.account_id}/${router.currentRoute.params.workspace_id}/file`;

      return api.get(url, { params })
        .then(res => {
          // merge the data with our local info
          commit('overwrite', res.data.encrypt.data)
          return resolve(res.data.encrypt.data)
        })
        .catch(err => {
          return reject(err)
        })
    })
  },
  removeCompany({ dispatch }, payload) {
    // delete all attachments related to a company
    return dispatch('apiDeleteFilesForCompany', payload)
  },
  deleteDocument({ commit }, payload) {
    // delete file
    if (_.isNil(payload) || _.isEmpty(payload)) return Promise.reject({ error: 'no arguments' })
    // delete the file with the given id
    let url = `/document/url/${payload._id}`;
    return api.post(url, {
      encrypt: {
        data: payload
      }
    })
      .then(res => {
        // remove the id from our local file list
        commit('remove', payload._id)
        // should be 204
        return Promise.resolve()
      })
      .catch(err => {
        console.error(`Error during file delete: ${err}`)
        return Promise.reject(err)
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}